<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="getFomatedValue"
        :label="label"
        :prepend-icon="prependIcon"
        :prepend-inner-icon="prependInnerIcon"
        :outlined="outlined"
        :hide-details="hideDetails"
        :solo="solo"
        :solo-inverted="soloInverted"
        :filled="filled"
        :class="{ 'no-before': noBefore }"
        readonly
        :loading="loading"
        :disabled="loading"
        :dense="dense"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="datesModel"
      range
      no-title
      scrollable
      :first-day-of-week="1"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="reset">Cancel</v-btn>
      <v-btn text color="primary" @click="save">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  name: "RangeDatePicker",
  props: {
    value: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    prependIcon: {
      type: String,
      default: ""
    },
    prependInnerIcon: {
      type: String,
      default: ""
    },
    outlined: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    noBefore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getFomatedValue() {
      if (this.value.length === 2) {
        return `${this.value[0]} à ${this.value[1]}`;
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      datesModel: [],
      menu: false
    };
  },
  methods: {
    reset() {
      this.menu = false;
      this.datesModel = this.value;
    },
    save() {
      this.menu = false;
      this.$emit(
        "input",
        this.datesModel.sort((a, b) => moment(a).diff(moment(b)))
      );
    }
  },
  watch: {
    menu(v) {
      if (v === true) {
        this.datesModel = this.value;
      }
    }
  }
};
</script>

<style></style>
